import { ISpecialPromosState } from '../../types/specialPromos';

const defaultState: ISpecialPromosState = {
  items: [],
};

export function specialPromosReducer(state: ISpecialPromosState = defaultState): ISpecialPromosState {
  return state;
}
